import React, { useEffect, useState } from 'react';
import { Button, Grid } from '@material-ui/core';
import { Add, Replay } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';

import GiaiThuongInsert from '../GiaiThuongInsert';
import { rewardActions} from '../../../../actions';

export default function GiaiThuongButton(props) {
  const dispatch = useDispatch();
  const profileId = useSelector(state => state.profileReducer.profile?.id);
  const totalRewardList = useSelector(state => state.rewardReducer.totalRewardList);
  const personalRewardList = useSelector(state => state.rewardReducer?.personalRewardList);

  const [inserting, setInserting] = useState(false);

  const handleClick = () => setInserting(true);
  const handleClose = () => setInserting(false);
  const handleReload = () => {
    if (props.filterType === 'person') {
      dispatch(rewardActions.getRewardByProfileId(profileId));
    } else {
      dispatch(rewardActions.getAllRewards());
    }
  }

  useEffect(() => {
    if (props.filterType === 'person' && !isNaN(profileId) && personalRewardList.length === 0) handleReload();
  }, [profileId]);

  useEffect(() => {
    if (props.filterType === 'all' && totalRewardList.length === 0) handleReload();
  }, []);



  return (
    <>
      <Grid item xs={12} md={3}>
        <div style={{ float: 'right' }}>
          <Button variant='outlined' startIcon={<Replay />} style={{ backgroundColor: 'white', marginRight: 8 }} onClick={handleReload} >Tải lại</Button>
          {props.filterType === 'person' && (
            <Button variant='contained' color='secondary' startIcon={<Add />} onClick={handleClick}>Thêm</Button>
          )}
        </div>
      </Grid>


      <GiaiThuongInsert open={inserting} onClose={handleClose} />
    </>
  );
}
